import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import {
  FaLaptopCode,
  FaGlobe,
  FaCloud,
  FaHeadset,
} from "react-icons/fa";
import AOS from "aos";
import "aos/dist/aos.css";


import { 
  FaChalkboardTeacher,
  FaClipboardList,
  FaBookOpen,
  FaUserFriends
} from "react-icons/fa";
import "../App.css";
import { FaFacebookF, FaInstagram, FaTwitter } from "react-icons/fa";


const buttonStyle = {
  background: '#3498db',
  color: 'white',
  border: 'none',
  padding: '10px 15px',
  cursor: 'pointer',
  fontSize: '1.5em',
  borderRadius: '5px',
  margin: '0 20px',
  transition: 'background 0.3s',
};
const cardStyle = {
  textAlign: 'center',
  padding: '20px',
  borderRadius: '10px',
  backgroundColor: 'white',
  boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
  width: '250px',
  flexShrink: 0,
};
const imageContainerStyle = {
  width: '150px',
  height: '150px',
  borderRadius: '50%',
  overflow: 'hidden',
  margin: '0 auto 20px',
  border: '4px solid #3498db',
};
const imageStyle = { width: '100%', height: '100%', objectFit: 'cover' };
const nameStyle = { fontSize: '1.5em', margin: '10px 0 5px', color: '#333' };
const subjectStyle = { color: '#666', fontSize: '1em' };

const Home = () => {
  const navigate = useNavigate();
  const [courseIndex, setCourseIndex] = useState(0);
  useEffect(() => {
  AOS.init({
    duration: 1000,
    once: true,
  });
}, []);

const heroSlides = [
 {
    title: "Digital Banking Solutions",
    description:
      "Experience secure and smart online banking services.",
    image:
      "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?q=80&w=1600&auto=format&fit=crop",
  },

  {
    title: "Easy Money Transfer",
    description:
      "Transfer money securely with fast digital banking services.",
    image:
      "https://images.unsplash.com/photo-1579621970795-87facc2f976d?q=80&w=1600&auto=format&fit=crop",
  },

  {
    title: "Smart Banking Experience",
    description:
      "Manage cards, savings, and transactions anytime.",
    image:
      "https://images.unsplash.com/photo-1559526324-593bc073d938?q=80&w=1600&auto=format&fit=crop",
  },

  {
    title: "Secure Online Payments",
    description:
      "Experience fast and secure payment solutions.",
    image:
        "https://images.unsplash.com/photo-1521791136064-7986c2920216?q=80&w=1600&auto=format&fit=crop",
  },
];
const [currentSlide, setCurrentSlide] = useState(0);
useEffect(() => {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: "instant",
  });
}, []);
useEffect(() => {

  const interval = setInterval(() => {

    setCurrentSlide((prev) =>
      (prev + 1) % heroSlides.length
    );

  }, 3000);

  return () => clearInterval(interval);

}, []);
const location = useLocation();
useEffect(() => {
  const params = new URLSearchParams(location.search);
  const section = params.get("section");

  if (section) {
    setTimeout(() => {
      const element = document.getElementById(section);

      if (element) {
        window.scrollTo({
          top: element.offsetTop - 80,
          behavior: "smooth",
        });
      }
    }, 100);
  }
}, [location]);
 const [currentIndex, setCurrentIndex] = useState(0);

 

  return (
    <div className="relative w-full">
      <div className="fixed inset-0 bg-black/40 -z-10"></div>
    <video
    autoPlay
    muted
    loop
    playsInline
    className="fixed inset-0 w-full h-full object-cover -z-20"
  >
    <source src="/videos/bg.mp4" type="video/mp4" />
  </video>

  <div className="fixed inset-0  -z-10"></div>
 <section
  id="home"
  className="relative min-h-[calc(100vh-80px)] overflow-hidden w-full"
>
  {/* <video
    autoPlay
    muted
    loop
    playsInline
    preload="auto"
    className="absolute inset-0 w-full h-full object-cover"
  >
    <source src="/videos/bg.mp4" type="video/mp4" />
  </video> */}
  

  <div className="relative z-10 min-h-[calc(100vh-80px)] flex flex-col justify-center items-center text-center px-6 text-white">
    
    <span className="uppercase tracking-[4px] text-sm md:text-base text-blue-300 font-medium mb-4">
      Trusted IT Solutions Partner
    </span>

    <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold leading-tight max-w-5xl mb-6">
      Leading Software Development Company
    </h1>

    <p className="text-lg md:text-2xl font-medium text-gray-200 max-w-3xl mb-6">
      Building Future-Ready Technology Solutions
    </p>

    <p className="text-base md:text-lg text-gray-300 leading-relaxed max-w-4xl">
      From custom web applications to enterprise software systems, we deliver
      end-to-end IT services tailored to your business goals. Our expert team
      leverages modern technologies to create secure, scalable, and
      user-friendly solutions that drive innovation, accelerate growth, and
      help businesses stay ahead in the digital era.
    </p>

    <div className="mt-10 flex flex-col sm:flex-row gap-4">

      <button className="px-8 py-3 border border-white hover:bg-white hover:text-black rounded-lg font-semibold transition bg-cyan-500" 
       onClick={() => navigate("/about")}>
        Learn More
      </button>
    </div>

  </div>
</section>
     
<div
  id="about"
  className="min-h-screen px-6 py-20 flex items-center justify-center"
>
  <div className="max-w-7xl mx-auto">

    <div className="text-center mb-16">
      <h2 className="text-4xl md:text-5xl font-bold text-white">
        Why Choose <span className="text-cyan-600">JK Solution?</span>
      </h2>

      <p className="mt-6 text-lg text-white max-w-3xl mx-auto">
        We provide innovative IT solutions that help businesses grow faster,
        improve efficiency, and stay ahead in the digital world.
      </p>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">

      <div
        data-aos="fade-up"
        className="p-8 rounded-2xl shadow-lg text-center hover:-translate-y-3 hover:shadow-2xl transition-all duration-500"
      >
        <FaLaptopCode className="text-cyan-500 bg-black-300  text-6xl mx-auto mb-5 animate-pulse" />

        <h3 className="text-xl font-semibold text-white">
          Custom Software
        </h3>

        <p className="text-white mt-3">
          Tailor-made software solutions designed to meet your business
          requirements and streamline operations.
        </p>
      </div>
      <div
        data-aos="fade-up"
        data-aos-delay="100"
        className=" p-8 rounded-2xl shadow-lg text-center hover:-translate-y-3 hover:shadow-2xl transition-all duration-500"
      >
        <FaGlobe className="text-cyan-500 text-6xl mx-auto bg-black-300  mb-5 animate-pulse" />

        <h3 className="text-xl font-semibold text-white">
          Web Development
        </h3>

        <p className="text-white mt-3">
          Responsive and modern websites built with the latest technologies
          for exceptional user experiences.
        </p>
      </div>

      <div
        data-aos="fade-up"
        data-aos-delay="200"
        className=" p-8 rounded-2xl shadow-lg text-center hover:-translate-y-3 hover:shadow-2xl transition-all duration-500"
      >
        <FaCloud className="text-cyan-500  text-6xl mx-auto mb-5 animate-pulse" />

        <h3 className="text-xl font-semibold text-white">
          Cloud Solutions
        </h3>

        <p className="text-white mt-3">
          Secure cloud integration, hosting, and infrastructure services
          to improve scalability and performance.
        </p>
      </div>

      <div
        data-aos="fade-up"
        data-aos-delay="300"
        className=" p-8 rounded-2xl shadow-lg text-center hover:-translate-y-3 hover:shadow-2xl transition-all duration-500"
      >
        <FaHeadset className="text-cyan-500 text-6xl mx-auto mb-5 animate-pulse" />

        <h3 className="text-xl font-semibold text-white">
          24/7 Support
        </h3>

        <p className="text-white mt-3">
          Dedicated technical support and maintenance services to keep
          your systems running smoothly.
        </p>
      </div>

    </div>
  </div>
</div>

  <div className="bg-black/70 backdrop-blur-md py-12">

        <div className="max-w-7xl mx-auto px-5">

          <div className="grid md:grid-cols-3 gap-10">

            <div>

              <h3 className="text-xl font-bold text-cyan-400 mb-3">
                Kerala Branch
              </h3>

             <p className="leading-7 text-white">
                1st Floor - JK Building
                <br />
                Kannur, Kannur 670684
                <br />
                Phone: +91 90000 90000
              </p>

              <h3 className="text-xl font-bold text-cyan-400 mt-6 mb-3">
                Tamil Nadu Branch
              </h3>

             <p className="leading-7 text-white">
                First Floor, D Block,
                <br />
                JK Park, chennai,
                <br />
                Chennai, Tamil Nadu 600100
                <br />
                Phone: +91 70000 80000
                <br />
                Email: jk@gmail.com
              </p>

            </div>

            <div>

              <h3 className="text-xl font-bold text-cyan-400 mb-5">
                Quick Links
              </h3>

              <ul className="space-y-3 text-white">

                <li  className="cursor-pointer" onClick={() => navigate("/home")}>Home</li>
                <li  className="cursor-pointer" onClick={() => navigate("/about")}>About Us</li>
                <li className="cursor-pointer"  onClick={() => navigate("/services")}>Services</li>
                <li  className="cursor-pointer" onClick={() => navigate("/product")}>Products</li>
             

              </ul>

            </div>

            <div>

              <h3 className="text-xl font-bold text-cyan-400 mb-5">
                More Links
              </h3>

              <ul className="space-y-3 text-white">

                <li  className="cursor-pointer" onClick={() => navigate("/careers")}>Career</li>
                <li className="cursor-pointer"  onClick={() => navigate("/events")}>Events</li>
                <li  className="cursor-pointer" onClick={() => navigate("/blogs")}>Blogs</li>

              </ul>

            </div>

          </div>

        </div>

      </div>

    </div>
  );
};

export default Home;
